import React from "react";
import { Chip, Tooltip } from "@mui/material";
import RouterOutlinedIcon from "@mui/icons-material/RouterOutlined";
import { formatTimeAgo } from "./deviceDisplay";

// «02:40» si es de hoy; si no, «3 nov 02:40».
const clock = (isoTime) => {
    const time = new Date(isoTime);
    if (Number.isNaN(time.getTime())) return null;
    const sameDay = time.toDateString() === new Date().toDateString();
    return sameDay
        ? time.toLocaleTimeString("es-CL", { hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
        : time.toLocaleString("es-CL", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
};

// Conexión de un gateway LoRaWAN con la nube, como la informa AWS: sin conexión, el local entero queda sin datos.
const GatewayStatusChip = ({ gateway, size = "small", withName = false }) => {
    if (!gateway) return null;

    const since = gateway.status_changed_at ? clock(gateway.status_changed_at) : null;
    const lastUplink = formatTimeAgo(gateway.last_uplink_at);
    let status = "sin informe de conexión";
    let color = "default";
    if (gateway.connection_status === "connected") {
        status = `conectado${lastUplink ? ` · último dato ${lastUplink}` : ""}`;
        color = "success";
    } else if (gateway.connection_status === "disconnected") {
        status = `sin conexión${since ? ` desde ${since}` : ""}`;
        color = "error";
    }
    const label = withName && gateway.name
        ? `${gateway.name}: ${status}`
        : `Gateway ${status}`;

    return (
        <Tooltip title={withName ? "" : gateway.name || ""}>
            <Chip
                size={size}
                color={color}
                variant={color === "default" ? "outlined" : "filled"}
                icon={<RouterOutlinedIcon />}
                label={label}
            />
        </Tooltip>
    );
};

export default GatewayStatusChip;
